import '../dashboard/Dashboard.css';
import { useState, useEffect } from 'react';
import styled from "styled-components";
import {useDashboardData} from './useDashboard';
import useUserSettingStore from './UserSettingStore';
import userProfileStore from "../core/UserProfileStore";
import { APP_ENV,  } from '../../constants';
import {unitStockingLinkUrl} from './DashboardConfig';

export const UNIT_STOCKING_DASHBOARD = {
  DASHBOARD_ID: 'unit-stocking-dashboard',
  DOMAIN_ID: 'unit-stocking',
  WIDGET_STOCK_AGING_ID: 'stock-aging',
  WIDGET_STOCK_MISSING_ID: 'stock-missing',
  WIDGET_STOCK_INV_STATUS_ID: 'stock-inventory-status',
  WIDGET_STOCK_INV_MARK_ID: 'stock-inventory-marketable',
  WIDGET_STOCK_INV_CAT_ID: 'stock-inventory-category',
};

export const WidgetHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px 8px;
  font-weight: 600;
  font-size: 20px;
  padding-bottom: 8px;
  justify-content: space-between;
`;


function formatString(str:string) {
  if (!str) return str; // Handle empty strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const getWidgets = (t:any) => {
 return [
  {
          id: UNIT_STOCKING_DASHBOARD.WIDGET_STOCK_AGING_ID,
          dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
          title: t('dashboard.unitStocking.lotAge'),
          link: unitStockingLinkUrl[APP_ENV as unknown as keyof typeof unitStockingLinkUrl],
          xKey: 'name',
          valueKey: 'count',
          availableViews: [ 'line', 'bar', 'pie', 'table' , 'grid' ],
          defaultView: 'bar',
          thresholdFields:[
            {name:"Current"},
            {name:"31 - 60d"},
            {name:"61 - 90d"},
            {name:"91+"},
          ],
          dataMapping: {
            transform: (sourceData:any) => {
              const stats = sourceData[0]?.searchResult?.summary?.counters?.statistics;
              if(!stats)
                return [];

              const lotAgeBin030 = stats.find((s:any) => s.entry.key === "lotAgeBin0-30")?.entry?.value;
              const lotAgeBin3160 = stats.find((s:any) => s.entry.key === "lotAgeBin31-60")?.entry?.value;
              const lotAgeBin6190 = stats.find((s:any) => s.entry.key === "lotAgeBin61-90")?.entry?.value;
              const lotAgeBin91 = stats.find((s:any) => s.entry.key === "lotAgeBin91+")?.entry?.value;
              return [
                { name: 'Current', count: lotAgeBin030 },
                { name: '31 - 60d', count: lotAgeBin3160 },
                { name: '61 - 90d', count: lotAgeBin6190 },
                { name: '91+', count:lotAgeBin91 },
            ]},
          },
      },
      {
          id: UNIT_STOCKING_DASHBOARD.WIDGET_STOCK_MISSING_ID,
          dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
          title: t('dashboard.unitStocking.missingItems'),
          link: unitStockingLinkUrl[APP_ENV as unknown as keyof typeof unitStockingLinkUrl],
          xKey: 'name',
          valueKey: 'count',
          availableViews: ['table' , 'grid' ],
          defaultView: 'grid',
          height:'480px',
          thresholdFields:[
            {name:"Featured Price"},
            {name:"VIN"},
            {name:"Dealer Image"},
            {name:"Odometer"},
            {name:"Dealer Video"},
            {name:"Exterior Color"},
            {name:"Description"},
            {name:"Warranty"},
            {name:"Trim"},
            {name:"Stock #"},
          ],
          dataMapping: {
            transform: (sourceData:any) => {
              const stats = sourceData[0]?.searchResult?.summary?.counters?.statistics;
               if(!stats)
                return [];
              const missingFeaturedPrice = stats.find((s:any) => s.entry.key === "missingFeaturedPrice")?.entry?.value;
              const zeroOdometerUsedVehicle = stats.find((s:any) => s.entry.key === "zeroOdometerUsedVehicle")?.entry?.value;
              const zeroDealerPhotos = stats.find((s:any) => s.entry.key === "zeroDealerPhotos")?.entry?.value;
              const zeroVideos = stats.find((s:any) => s.entry.key === "zeroVideos")?.entry?.value;
              const missingVin = stats.find((s:any) => s.entry.key === "missingVin")?.entry?.value;
              const missingExteriorColor = stats.find((s:any) => s.entry.key === "missingExteriorColor")?.entry?.value;
              const missingDescription = stats.find((s:any) => s.entry.key === "missingDescription")?.entry?.value;
              const missingWarranty = stats.find((s:any) => s.entry.key === "missingWarranty")?.entry?.value;
              const missingTrim = stats.find((s:any) => s.entry.key === "missingTrim")?.entry?.value;
              const missingStockNumber = stats.find((s:any) => s.entry.key === "missingStockNumber")?.entry?.value;
              return [
                { name: 'Featured Price', count: missingFeaturedPrice },
                { name: 'VIN', count: missingVin },
                { name: 'Dealer Image', count: zeroDealerPhotos },
                { name: 'Odometer', count: zeroOdometerUsedVehicle },
                { name: 'Dealer Video', count: zeroVideos},
                { name: 'Exterior Color', count: missingExteriorColor },
                { name: 'Description', count:missingDescription },
                { name: 'Warranty', count:missingWarranty},
                { name: 'Trim', count:missingTrim },
                { name: 'Stock #', count:missingStockNumber},
            ]},
          },
      },
      {
          id: UNIT_STOCKING_DASHBOARD.WIDGET_STOCK_INV_STATUS_ID,
          dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
          title: t('dashboard.unitStocking.invStatus'),
          xKey: 'name',
          link: unitStockingLinkUrl[APP_ENV as unknown as keyof typeof unitStockingLinkUrl],
          valueKey: 'count',
          availableViews: ['bar', 'pie', 'table' , 'grid'  ],
          defaultView: 'bar',
          thresholdFields:[
            {name:"In-production"},
            {name:"On-order"},
            {name:"In-stock"},
            {name:"In-transit"},
            {name:"Invoiced"},
            {name:"Hold"},
          ],
          dataMapping: {
            transform: (sourceData:any) => {
              const stats = sourceData[0]?.searchResult?.summary?.counters?.inventoryStatus;
               if(!stats)
                return [];
              const production = stats.find((s:any) => s.entry.key === "In-production")?.entry?.value;
              const order = stats.find((s:any) => s.entry.key === "On-order")?.entry?.value;
              const stock = stats.find((s:any) => s.entry.key === "In-stock")?.entry?.value;
              const transit = stats.find((s:any) => s.entry.key === "In-transit")?.entry?.value;
              const invoiced = stats.find((s:any) => s.entry.key === "Invoiced")?.entry?.value;
              const hold = stats.find((s:any) => s.entry.key === "Hold")?.entry?.value;
              return [
                { name: 'In-production', count: production},
                { name: 'On-order', count: order },
                { name: 'In-stock', count: stock },
                { name: 'In-transit', count: transit },
                { name: 'Invoiced', count: invoiced},
                { name: 'Hold', count: hold},
            ]},
          },
      },
      {
          id: UNIT_STOCKING_DASHBOARD.WIDGET_STOCK_INV_MARK_ID,
          dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
          title: t('dashboard.unitStocking.marketable'),
          link: unitStockingLinkUrl[APP_ENV as unknown as keyof typeof unitStockingLinkUrl],
          xKey: 'name',
          valueKey: 'count',
          availableViews: ['bar', 'pie', 'table' , 'grid' ],
          defaultView: 'bar',
          thresholdFields:[
            {name:"Marketable"},
            {name:"Un marketable"},
          ],
          dataMapping: {
            transform: (sourceData:any) => {
              const stats = sourceData[0]?.searchResult?.summary?.counters?.marketable;
              if(!stats)
                return [];
              const marketable = stats.find((s:any) => s.entry.key === "true")?.entry?.value;
              const unmarketable = stats.find((s:any) => s.entry.key === "false")?.entry?.value;
              return [
                { name: 'Marketable', count: marketable },
                { name: 'Un marketable', count: unmarketable },
            ]}
          },
      },
      {
          id: UNIT_STOCKING_DASHBOARD.WIDGET_STOCK_INV_CAT_ID,
          dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
          title: t('dashboard.unitStocking.category'),
          xKey: 'name',
          link: unitStockingLinkUrl[APP_ENV as unknown as keyof typeof unitStockingLinkUrl],
          valueKey: 'count',
          availableViews: ['bar', 'pie','table' , 'grid' ],
          defaultView: 'bar',
          thresholdFields:[
            {name:"New"},
            {name:"Pre Owned"},
            {name:"Certified"},
          ],
          dataMapping: {
            transform: (sourceData:any) => {
              const stats = sourceData[0]?.searchResult?.summary?.counters?.category;
              if(!stats)
                return [];
              return stats?.map((s:any) =>{
                return { name : formatString(s.entry.key), count: s.entry.value}
              })
            }
          },
      },
    ];
}

export const getDashboardConfig = (currentStoreId:any) =>{
  const config = [];
    config.push( 
          {
            id: 'unit-stocking-query',
            name: 'Unit Stocking',
            layout: 'default',
            apiConfig: {
              method:'GET',
              queryParams:{
                  'filters': 'true',
                  'includeStatistics':'true',
                  'inventoryStatus':['On-order','In-production','Invoiced','In-transit','In-stock','Hold'],
                  'locale':'en_US',
                  'marketable':'all',
                  'storeId':currentStoreId,
                  'summaryOnly':'true'

              },
              endpoint: '/api/getVehicleDashboardDetails',
            },
          });
  return config;
}


export const useUnitStockingDashboard = ({ enabled = true, filteredWidgets = [] }: { enabled?: boolean; filteredWidgets?: any[] } = {}) => {
  const {currentStoreId} = userProfileStore();
  const [config, setConfig] = useState() as any;
  const { userSetting } = useUserSettingStore();
  const {isLoading, error, getWidgetData } = useDashboardData({config,enabled: enabled && !!config}) as any;
  const [widgets , setWidgets] = useState(filteredWidgets) as any;

    useEffect(()=>{
      if(currentStoreId){
        setConfig(getDashboardConfig(currentStoreId));
      }
    },[currentStoreId])
    

    useEffect(() => {
      if (userSetting) {
        const dashboard = userSetting.dashboard?.find((dash: any) => dash.id === UNIT_STOCKING_DASHBOARD.DASHBOARD_ID);
        const savedWidgets = dashboard?.widgets || [];
        const updatedWidgets = 
          filteredWidgets.map((dwidget: any) => {
            const savedWidget = savedWidgets.find((w: any) => w.id === dwidget.id);
            return {
              ...dwidget,
              dashboardId: UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
              fields: savedWidget?.fields,
              view: savedWidget?.view,
            };
          });
        setWidgets(updatedWidgets);
  
      }
    }, [userSetting, filteredWidgets]);

    return {
      dashboardId:UNIT_STOCKING_DASHBOARD.DASHBOARD_ID,
      widgets,
      isLoading: enabled ? (isLoading || !config) : false,
      error,
      getWidgetData,
  };

}
